import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { SplashScreen } from './components/SplashScreen';
import { LoginScreen } from './components/LoginScreen';
import { TermsScreen } from './components/TermsScreen';
import { SignupScreen } from './components/SignupScreen';
import { VerificationScreen } from './components/VerificationScreen';
import { OTPScreen } from './components/OTPScreen';
import { HomeScreen } from './components/HomeScreen';
import { PaymentsScreen } from './components/PaymentsScreen';
import { CardsScreen } from './components/CardsScreen';
import { RewardsScreen } from './components/RewardsScreen';
import { BottomNav } from './components/BottomNav';
import { TransactionsScreen } from './components/TransactionsScreen';
import { SendMoneyScreen } from './components/SendMoneyScreen';
import { MPINScreen, MPINMode, PinType } from './components/MPINScreen';
import { LanguageProvider } from './utils/translations';
type AppScreen = 'splash' | 'login' | 'terms' | 'signup' | 'verification' | 'otp' | 'mpin' | 'home' | 'payments' | 'cards' | 'rewards' | 'transactions' | 'send-money';
export function App() {
  const [currentScreen, setCurrentScreen] = useState<AppScreen>('splash');
  const [mpinMode, setMpinMode] = useState<MPINMode>('enter');
  const [mpinType, setMpinType] = useState<PinType>('login');
  const [isNewUser, setIsNewUser] = useState(false);
  const [isMpinSet, setIsMpinSet] = useState(false);
  const handleSplashComplete = () => {
    setCurrentScreen('login');
  };
  const handleLogin = () => {
    setIsNewUser(false);
    setCurrentScreen('home');
  };
  const handleNavigateToSignup = () => {
    setCurrentScreen('terms');
  };
  const handleTermsBack = () => {
    setCurrentScreen('login');
  };
  const handleTermsAccept = () => {
    setCurrentScreen('signup');
  };
  const handleSignupBack = () => {
    setCurrentScreen('terms');
  };
  const handleSignupContinue = () => {
    setCurrentScreen('verification');
  };
  const handleVerificationBack = () => {
    setCurrentScreen('signup');
  };
  const handleVerificationContinue = () => {
    setCurrentScreen('otp');
  };
  const handleOTPBack = () => {
    setCurrentScreen('verification');
  };
  const handleOTPVerify = () => {
    setIsNewUser(true);
    setMpinMode('set');
    setMpinType('login');
    setCurrentScreen('mpin');
  };
  const handleMPINComplete = () => {
    if (mpinType === 'mpin') {
      setIsMpinSet(true);
    }
    setCurrentScreen('home');
  };
  const handleMPINBack = () => {
    if (mpinMode === 'enter') {
      setCurrentScreen('login');
    } else {
      setCurrentScreen('otp');
    }
  };
  const handleLogout = () => {
    setIsNewUser(false);
    setIsMpinSet(false);
    setCurrentScreen('splash');
  };
  const handleNavigateToTransactions = () => {
    setCurrentScreen('transactions');
  };
  const handleNavigateToSendMoney = () => {
    setCurrentScreen('send-money');
  };
  const handleNavigate = (screen: 'home' | 'payments' | 'cards' | 'rewards') => {
    setCurrentScreen(screen);
  };
  const showBottomNav = !['splash', 'login', 'terms', 'signup', 'verification', 'otp', 'mpin', 'transactions', 'send-money'].includes(currentScreen);
  return <LanguageProvider data-id="element-0">
      <div className="w-full min-h-screen bg-[#FFF5F0]" data-id="element-1">
        <div className="max-w-[430px] mx-auto min-h-screen bg-[#FFF5F0] relative overflow-hidden" data-id="element-2">
          <AnimatePresence mode="wait" data-id="element-3">
            {currentScreen === 'splash' && <SplashScreen key="splash" onComplete={handleSplashComplete} data-id="element-4" />}
            {currentScreen === 'login' && <LoginScreen key="login" onLogin={handleLogin} onNavigateToSignup={handleNavigateToSignup} data-id="element-5" />}
            {currentScreen === 'terms' && <TermsScreen key="terms" onBack={handleTermsBack} onAccept={handleTermsAccept} data-id="element-6" />}
            {currentScreen === 'signup' && <SignupScreen key="signup" onBack={handleSignupBack} onContinue={handleSignupContinue} data-id="element-7" />}
            {currentScreen === 'verification' && <VerificationScreen key="verification" onBack={handleVerificationBack} onContinue={handleVerificationContinue} data-id="element-8" />}
            {currentScreen === 'otp' && <OTPScreen key="otp" onBack={handleOTPBack} onVerify={handleOTPVerify} data-id="element-9" />}
            {currentScreen === 'mpin' && <MPINScreen key="mpin" mode={mpinMode} pinType={mpinType} onModeChange={setMpinMode} onComplete={handleMPINComplete} onBack={handleMPINBack} data-id="element-10" />}
            {currentScreen === 'home' && <HomeScreen key="home" isNewUser={isNewUser} isMpinSet={isMpinSet} onNavigateToTransactions={handleNavigateToTransactions} onNavigateToSendMoney={handleNavigateToSendMoney} onNavigateToPayments={() => setCurrentScreen('payments')} onLogout={handleLogout} onSetMPIN={() => {
            setMpinMode('set');
            setMpinType('mpin');
            setCurrentScreen('mpin');
          }} data-id="element-11" />}
            {currentScreen === 'transactions' && <TransactionsScreen key="transactions" onBack={() => setCurrentScreen('home')} data-id="element-12" />}
            {currentScreen === 'send-money' && <SendMoneyScreen key="send-money" onBack={() => setCurrentScreen('home')} data-id="element-13" />}
            {currentScreen === 'payments' && <PaymentsScreen key="payments" data-id="element-14" />}
            {currentScreen === 'cards' && <CardsScreen key="cards" data-id="element-15" />}
            {currentScreen === 'rewards' && <RewardsScreen key="rewards" data-id="element-16" />}
          </AnimatePresence>

          {showBottomNav && <BottomNav activeScreen={currentScreen as 'home' | 'payments' | 'cards' | 'rewards'} onNavigate={handleNavigate} data-id="element-17" />}
        </div>
      </div>
    </LanguageProvider>;
}